import { useTheme, useMediaQuery } from '@mui/material';

// Custom hook for responsive breakpoints
export const useResponsive = () => {
  const theme = useTheme();
  
  return {
    isMobile: useMediaQuery(theme.breakpoints.down('sm')),
    isTablet: useMediaQuery(theme.breakpoints.between('sm', 'lg')),
    isDesktop: useMediaQuery(theme.breakpoints.up('lg')),
    isSmallScreen: useMediaQuery(theme.breakpoints.down('md')),
    isLargeScreen: useMediaQuery(theme.breakpoints.up('xl'))
  };
};

// Responsive chart dimensions
export const getResponsiveChartDimensions = (breakpoint) => {
  const dimensions = {
    mobile: { width: 350, height: 250 },
    tablet: { width: 600, height: 350 },
    desktop: { width: 900, height: 400 },
    large: { width: 1200, height: 500 }
  };

  switch (breakpoint) {
    case 'mobile':
      return dimensions.mobile;
    case 'tablet':
      return dimensions.tablet;
    case 'desktop':
      return dimensions.desktop;
    case 'large':
      return dimensions.large;
    default:
      return dimensions.desktop;
  }
};

// Responsive grid columns
export const getResponsiveColumns = (breakpoint) => {
  switch (breakpoint) {
    case 'mobile':
      return { xs: 12 };
    case 'tablet':
      return { xs: 12, md: 6 };
    case 'desktop':
      return { xs: 12, md: 6, lg: 4 };
    default:
      return { xs: 12, md: 6, lg: 4, xl: 3 };
  }
};

// Chart configuration based on screen size
export const getResponsiveChartConfig = (isMobile, isTablet) => {
  if (isMobile) {
    return {
      displayModeBar: false,
      responsive: true,
      layout: {
        margin: { t: 20, l: 40, r: 20, b: 40 },
        legend: { orientation: 'h', y: -0.3 },
        font: { size: 10 }
      }
    };
  }
  
  if (isTablet) {
    return {
      displayModeBar: true,
      responsive: true,
      layout: {
        margin: { t: 30, l: 50, r: 30, b: 60 },
        legend: { orientation: 'h', y: -0.2 },
        font: { size: 12 }
      }
    };
  }
  
  return {
    displayModeBar: true,
    responsive: true,
    layout: {
      margin: { t: 30, l: 60, r: 30, b: 80 },
      legend: { orientation: 'h', y: -0.2 },
      font: { size: 14 }
    }
  };
};
